module.exports = __webpack_public_path__ + "files/674a000fb23cb7ecbeb2c2dda24d6111.png";